import { Box, Image, Text } from "@chakra-ui/react";
import "./styles.css";
import React from "react";
import { color } from "../../utils/theme";

interface IndicatorProps {
  title: string;
  onClickModal: () => void;
  onInfoClick: () => void;
}

const Indicator: React.FC<IndicatorProps> = ({
  title,
  onClickModal,
  onInfoClick,
}) => {
  return (
    <Box
      sx={{
        h: 50,
        w: "100%",
        pl: 5,
        cursor: "pointer",
        display: "flex",
        flexDirection: "row",
        gap: 5,
        justifyContent: "space-between",
        alignItems: "center",
        alignContent: "center",
        borderRadius: "md",
        fontFamily: "body",
        borderColor: "gray.300",
        borderWidth: 1,
        color: color.text,
        transition: "all 0.5s ease",
      }}
      boxShadow={"sm"}
      _hover={{
        shadow: "md",
        borderWidth: 1,
        color: color.primary,
        borderColor: color.primary,
        backgroundColor: "white.800",
      }}
    >
      <Box
        flex={1}
        alignContent={"center"}
        h={50}
        onClick={() => {
          console.log("huihu");
          onClickModal();
        }}
      >
        <Text fontSize={16}>{title}</Text>
      </Box>
      <Box
        onClick={onInfoClick}
        borderLeftColor={"#f2f2f2"}
        borderRightRadius={"md"}
        alignContent={"center"}
        pr={3}
        h={50}
      >
        <Image
          src={require(`../../assets/information.png`)}
          style={{ width: "40px" }}
          ml={3}
        />
      </Box>
    </Box>
  );
};

export default Indicator;
